module.exports = __webpack_public_path__ + "img/67.ba0e8e67.jpg";